<template>
    <el-container>
        <el-header style="height:60px;padding:0px;display:flex;background-color:#545c64">
            <!-- LOGO -->
            <img @click="onHome" id="logo" :src="logo" :onerror="onImgError" style="padding: 12px 15px 12px 12px; cursor: pointer;height: fit-content;max-width: 200px;" alt="">
            <!-- 顶部导航栏（用于在列表时显示导航，看板时显示标题及工具栏） -->
            <router-view id="toolbar" name="toolbar"></router-view>
            <!-- 右上角功能区 -->
            <el-menu style="margin-left:auto;" mode="horizontal" :ellipsis="false"
                background-color="#545c64" text-color="#fff" active-text-color="#fff" @select="onMenuSelect">
                <el-sub-menu class="tw-tablet-menu-item" index="more">
                    <template #title><i class="el-icon-menu"></i><span id="more">更多</span></template>
                    <tw-tablet-submenu :menus="mainMenus"></tw-tablet-submenu>
                </el-sub-menu>
                <el-sub-menu class="tw-tablet-menu-item" index="user-head">
                    <template #title>
                        <img id="user-head">
                    </template>
                    <el-menu-item v-if="userType === 'root'" class="tw-tablet-menu-item" index="options">
                        <i class="el-icon-setting"></i>
                        <template #title><span>系统参数</span></template>
                    </el-menu-item>
                    <el-menu-item v-if="userType === 'root'" class="tw-tablet-menu-item" index="sobs">
                        <i class="el-icon-s-management"></i>
                        <template #title><span>账套管理</span></template>
                    </el-menu-item>
                    <el-menu-item v-if="userType === 'root' || userType === 'admin'" class="tw-tablet-menu-item" index="user">
                        <i class="el-icon-user-solid"></i>
                        <template #title><span>用户权限</span></template>
                    </el-menu-item>
                    <el-menu-item class="tw-tablet-menu-item" index="profile">
                        <i class="el-icon-bank-card"></i>
                        <template #title><span>个人信息</span></template>
                    </el-menu-item>

                    <template v-if="sobList.length > 1">
                        <el-menu-item v-for="(sob, index) in sobList" :key="sob.sob_no" class="tw-tablet-menu-item" :index="`sob_no:${sob.sob_no}`">
                            <el-divider v-if="index === 0" style="margin:0px;"></el-divider>
                            <i v-if="sob.use" class="el-icon-check"></i>
                            <template #title><span :style="{ margin: `${sob.use ? 0 : 29}px`}">{{sob.sob_name}}</span></template>
                        </el-menu-item>
                    </template>

                    <el-menu-item class="tw-tablet-menu-item" index="update">
                        <el-divider style="margin:0px;"></el-divider>
                        <i class="el-icon-switch"></i>
                        <template #title><span>检查更新</span></template>
                    </el-menu-item>

                    <el-menu-item class="tw-tablet-menu-item" index="logout">
                        <el-divider style="margin:0px;"></el-divider>
                        <i class="el-icon-switch"></i>
                        <template #title><span>注销</span></template>
                    </el-menu-item>

                    <el-menu-item v-if="userType === 'root' || userType === 'admin'" class="tw-tablet-menu-item" index="exit">
                        <i class="el-icon-close"></i>
                        <template #title><span>退出</span></template>
                    </el-menu-item>
                </el-sub-menu>
            </el-menu>
        </el-header>

        <el-main style="height:calc(100vh - 60px); padding:0px; background-color:#f2f2f2;">
            <!-- 内容区 -->
            <div style="position:relative; height:100%; overflow-x:auto; overflow-y:auto;margin: 0px;background-color: var(--surface-ground);font-family: var(--font-family);font-weight: normal;color: var(--text-color);-webkit-font-smoothing: antialiased;">
                <router-view v-slot="{ Component }">
                    <!-- <keep-alive> -->
                        <component :is="Component" />
                    <!-- </keep-alive> -->
                </router-view>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import { onMounted, onUnmounted, provide, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

import userService from '../../services/user.service'
import httpService from '../../services/http.service'
import systemService from '../../services/system.service'
// import { ServiceProvider } from 'tw-data-source'
// import dataService from '../../services/data.service'
import twTabletSubmenu from './submenus'
import eventBus from '../../utils/event-bus'

export default {
    name: 'tw-tablet-main',
    components: {
        twTabletSubmenu
    },
    setup() {
        // 防止刷新未加载到主题
        const theme = localStorage.getItem('tw_design_theme');
        var themeElement = document.getElementById('theme-link');

        if(themeElement && theme){
            themeElement.setAttribute('href', themeElement.getAttribute('href').replace('saga-blue', theme));
        }

        const router = useRouter()
        const route = useRoute()

        // // 将数据服务给数据源的服务提供商，用于数据源内部获取数据（数据绑定的下拉选择）
        // ServiceProvider.dataService = dataService

        let socket

        const logo = `${process.env.BASE_URL}img/${userService.user.sob_no}.png`
        const userType = userService?.user?.user_type ?? 'user'
        // document.title = userService?.user?.sob_name
        const sobList = ref([])

        httpService.get('sob-list', { app_no: systemService.project_id }).then(result => {
            sobList.value = result.map(el => {
                return {
                    use: el.sob_no === userService.user.sob_no,
                    sob_no: el.sob_no,
                    sob_name: el.sob_name
                }
            })
        })

        const update = function() {
            httpService.get('update').then(result => {
                if (result) {
                    ElMessage.info({
                        showClose: true,
                        message: '已经是最新版本'
                    })
                } else {
                    ElMessageBox.confirm(`存在新版本，是否更新？`, '更新提示', {
                        confirmButtonText: '更新',
                        cancelButtonText: '取消'
                    }).then(() => {
                        httpService.put('update').then(() => {
                            ElMessage.success({
                                showClose: true,
                                message: '已成功更新，按 F5 刷新页面'
                            })
                        }).catch(err => {
                            ElMessage.info({
                                showClose: true,
                                message: err.message ?? err
                            })
                        })
                    }).catch(() => {

                    })
                }
            }).catch(err => {
                ElMessage.info({
                    showClose: true,
                    message: err.message ?? err
                })
            })
        }

        const getMainMenus = function() {
            // 解析 link 时路径中的参数，为了实现动态 url，例如需要跳转到旧看板时带上账套编号
            function parseUrlParams(url) {
                if (url.indexOf('{') !== -1) {
                    // 存在花括号代表有参数需要替换
                    /* 可使用的参数例子
                    app_no: "6178f1bc9f3414270155c9e3"
                    sob_no: "0001"
                    user_id: "97710894359781709"
                    */
                    ['app_no', 'sob_no', 'user_id'].forEach(key => {
                        const keyword = new RegExp(`{${key}}`, 'g')
                        url = url.replace(keyword, userService.user[key])
                    })
                }
                return url
            }
            // 获取所有子节点（包括子节点的子节点），返回子节点数组
            function getAllChildrens(items) {
                const result = []
                
                items.filter(el => el.type === 'folder' || userService.isPower(el.id)).forEach(el => {

                    let thumbnail = el.thumbnail
                    if (thumbnail && thumbnail[0] === '/') {
                        thumbnail = process.env.BASE_URL + thumbnail.substr(1)
                    }

                    switch (el.type) {
                        case 'page':
                            result.push({
                                id: el.id,
                                icon: el.icon,
                                label: el.label,
                                type: el.type,
                                file_name: el.file_name,
                                thumbnail: thumbnail ?? `${process.env.BASE_URL}static/thumbnails/${el.file_name ? el.file_name + '.png' : 'empty.svg' }`
                            })
                            break;
                        case 'link':
                            result.push({
                                id: el.id,
                                icon: el.icon,
                                label: el.label,
                                type: el.type,
                                url: parseUrlParams(el.url),
                                thumbnail: thumbnail
                            })
                            break;
                        default:
                            break;
                    }

                    if (el.children) {
                        result.push(...getAllChildrens(el.children))
                    }
                })
                return result
            }

            return systemService.menus.filter(el => el.type === 'folder' || userService.isPower(el.id)).map(el => {
                const item = {
                    id: el.id,
                    icon: el.icon,
                    label: el.label,
                    type: el.type
                }

                let thumbnail = el.thumbnail
                if (thumbnail && thumbnail[0] === '/') {
                    thumbnail = process.env.BASE_URL + thumbnail.substr(1)
                }

                if (el.type === 'page') {
                    item.file_name = el.file_name,
                    item.thumbnail = thumbnail ?? `${process.env.BASE_URL}static/thumbnails/${el.file_name ? el.file_name + '.png' : 'empty.svg' }`
                }

                if (el.type === 'link') {
                    item.url = parseUrlParams(el.url),
                    item.thumbnail = thumbnail
                }

                if (el.children) {
                    item.children = getAllChildrens(el.children)
                }

                return item
            })
        }

        const mainMenus = getMainMenus()
        provide('sys_main_menus', mainMenus);

        const onMenuSelect = function(key, keyPath) {
            switch (key) {
                case 'options': // 系统参数
                    router.push( { name: 'options' })
                    break;
                case 'sobs': // 账套管理
                    router.push({ name: 'sobs' })
                    break;
                case 'user': // 用户权限
                    router.push({ name: 'user' })
                    break;
                case 'profile': // 个人信息
                    router.push({ name: 'profile' })
                    break;
                case 'update':
                    update()
                    break;
                case 'logout': // 注销
                    ElMessageBox.confirm(`确定要注销当前登录用户吗？`, '注销提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        userService.logout()
                        router.push({ name: 'login' })
                    }).catch(() => {

                    })
                    break;
                case 'exit': // 用户退出
                    if (window.api?.closeWidget) {
                        // 有 APICloud 的 api 接口时调用关闭窗口
                        window.api?.closeWidget()
                    } else {
                        // 关闭浏览器
                        ElMessageBox.confirm(`确定要退出程序吗？`, '退出提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            if (window.api) {
                                // 由于使用 APICloud 封装成 app 时个别设备使用 webBrowser 模块打开页面（此时存在 api 对象，但没有 closeWidget 方法）
                                // 为了实现关闭需要改变 url 地址（可以通过回调得到地址变化），从而判断是否退出，由 APICloud 端进行退出
                                // 作为约定，使用 URL 加查询参数 ?exit=true 代表退出（exit只要不是空即会退出，同时可以返回具体退出代码，如：exit=123）
                            
                                userService.logout()
                                // 使用 vue-router 的 push APICloud 无法捕抓到变化，改用 location.href
                                // router.push({ name: 'login', query: { exit: 'true' } })
                                window.location.href = `${process.env.BASE_URL}login?exit=true`
                            } else {
                                open(location, '_self').close()
                            }
                        }).catch(() => {

                        })
                    }
                    break;
                default:
                    if (key.indexOf('sob_no:') !== -1) {
                        const sobNo = key.slice(7)
                        // 账套不相同时才进行切换
                        if (userService.user.sob_no !== sobNo) {
                            const sob = sobList.value.find(el => el.sob_no === sobNo)
                            ElMessageBox.confirm(`确定要切换到【${sob.sob_name}】账套吗？`, '提示信息', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                // 不使用路由跳转是因为路由跳转时不触发 beforeunload 事件，虽然可以手动在这里调用相关函数（例如保存个人配置等），
                                // 但使用 window.location.href 进行跳转可以使用正常的流程，且切换账套更为干净（刷新了浏览器）
                                // router.push({ name: 'login-passport', query: { token: userService.user.token, sob_no: sobNo } })
                                window.location.href = `${window.location.origin}${process.env.BASE_URL}login-passport?token=${userService.user.token}&sob_no=${sobNo}`
                            }).catch(() => {

                            })
                        }
                    } else {
                        // keyPath 是一个菜单主键的数组，第一个元素为第一层的主键，第二个元素为第二层的主键
                        const findMenu = function(menus, keyPath) {
                            const menu = menus.find(el => el.id === keyPath[0])
                            if (menu) {
                                if (keyPath.length > 1) {
                                    return findMenu(menu.children, keyPath.slice(1))
                                } else {
                                    return menu
                                }
                            }
                        }
                        // 第一层是固定的更多菜单项，需要去除
                        const menu = findMenu(mainMenus, keyPath.slice(1))
                        switch (menu.type) {
                            case 'page':
                                if (menu?.file_name) {
                                    router.push({ name: menu.file_name })
                                } else {
                                    ElMessage.info({
                                        showClose: true,
                                        message: '此项未配置页面！'
                                    })
                                }
                                break;
                            case 'link':
                                if (menu?.url) {
                                    window.open(menu.url)
                                } else {
                                    ElMessage.info({
                                        showClose: true,
                                        message: '此项未配置外链地址！'
                                    })
                                }
                                break;
                            default:
                                ElMessage.info({
                                    showClose: true,
                                    message: `不可识别的页面类型 ${key.type}！`
                                })
                                break;
                        }
                    }
                    break;
            }
        }

        const onHome = function() {
            router.push({ name: 'list' })
        }

        const onImgError = function(event) {
            const img = event.srcElement
            img.onerror = null
            img.src = `${process.env.BASE_URL}img/logo.png`
        }

        const onKeyDown = function(e) {
            if (e.code === 'Escape') {
                if (route.name !== 'list') {
                    router.back()
                }
            }
        }

        const onBeforeunload = function() {
            // 关闭 WebSocket
            socket?.close()
            // 保存最后一次打开的页面
            userService.setPropertyValue('last_open_route_name', route.name)
        }

        const initWebSocket = function() {
            if(typeof(WebSocket) === "undefined") {
                console.error('您的浏览器不支持 WebSocket')
            } else {
                if (process?.env?.VUE_APP_WEBSOCKET_URL) {

                    let baseUrl = process.env.VUE_APP_WEBSOCKET_URL
                    if (baseUrl.indexOf('{') !== -1) {
                        // 存在花括号代表有参数需要替换
                        /* 可使用的参数例子
                        host: "localhost:8080"
                        hostname: "localhost"
                        origin: "http://localhost:8080"
                        port: "8080"
                        protocol: "http:"
                        */
                        ['host', 'hostname', 'origin', 'port', 'protocol'].forEach(key => {
                            const keyword = new RegExp(`{${key}}`, 'g')
                            baseUrl = baseUrl.replace(keyword, window.location[key])
                        })
                    }

                    socket = new WebSocket(`${baseUrl}?token=${userService.user.token}`);
                    socket.onopen = () => {
                        // console.log('连接成功')
                    }
                    socket.onerror = () => {
                        // console.error('连接错误')
                    }
                    socket.onmessage = (msg) => {
                        const data = JSON.parse(msg?.data ?? "{}")
                        eventBus.emit('SYSTEM_WEBSOCKET_EVENT', data)
                    }
                    socket.onclose = () => {
                        // console.log('关闭连接')
                    }
                }
            }
        }

        onMounted(() => {
            document.addEventListener('keydown', onKeyDown, true)
            // 关闭或刷新浏览器时保存最后打开的页面
            window.addEventListener('beforeunload', onBeforeunload, true)

            try {
                initWebSocket()
            } catch {
                // 捕抓异常是为了在启用 WebSocket 失败时不至于整个网站崩了，错误信息本身会输出在控制台，所以也不需要输出
            }
        })

        onUnmounted(() => {
            document.removeEventListener('keydown', onKeyDown, true)
            window.removeEventListener('beforeunload', onBeforeunload, true)
        })

        return {
            logo,
            mainMenus,
            onMenuSelect,
            onHome,
            onImgError,
            userType,
            sobList
        }
    }
}
</script>

<style>
/* 所有菜单不要活动项下划线，不允许选中文本 */
.tw-tablet-menu-item {
    border-bottom:none !important;
    user-select: none;
}
.tw-tablet-menu-item>.el-sub-menu__title {
    border-bottom-color: #545c64 !important;
}
/* #logo {
    content:url(../../assets/img/logo_0224.png);
} */
#user-head {
    border-radius: 15px;
    width: 30px;
    height: 30px;
    content: url(../../assets/img/head_boy.png);
}
@media screen and (max-width: 775px) {
    #logo {
        display: none;
    }
    #toolbar {
        margin-left: 10px;
    }
    #more {
        display: none;
    }
}
</style>